import axios from "axios";
import { ApiRequest } from "../types";

export const apiRequest = (requestParams: ApiRequest) => {
  const { requestMethod, url, params } = requestParams;
  return axios[requestMethod](url, params).then((response) => response.data);
};
